import * as React from 'react';
import { createRoot } from 'react-dom/client';
import Tooltip from '@mui/material/Tooltip';
import {isNullOrNaN} from '../Bs4Components/Bs4Utils';


export const getMoney = (floatVal, formatterParams) => {
  floatVal = parseFloat(floatVal);
  let sign = "";
  let number, integer, decimal, rgx;

  const decimalSym = formatterParams.decimal || ".";
  // const thousandSym = formatterParams.thousand || ",";
  const thousandSym = formatterParams.thousand || false;
  const negativeSign = formatterParams.negativeSign || "-";
  const symbol = formatterParams.symbol || "";
  const after = !!formatterParams.symbolAfter;
  const precision = typeof formatterParams.precision !== "undefined" ? formatterParams.precision : 2;

  if(isNullOrNaN(floatVal)) {
    return '';
  }

  if(floatVal < 0){
    floatVal = Math.abs(floatVal);
    sign = negativeSign;
  }

  number = precision !== false ? floatVal.toFixed(precision) : floatVal;
  number = String(number).split(".");

  integer = number[0];
  decimal = number.length > 1 ? decimalSym + number[1] : "";

  if (formatterParams.thousand !== false) {
    rgx = /(\d+)(\d{3})/;

    while (rgx.test(integer)){
      integer = integer.replace(rgx, "$1" + thousandSym + "$2");
    }
  }

  return after ? sign + integer + decimal + symbol : sign + symbol + integer + decimal;  
}

const isRowInFooter = (element, level) => {  
  if (!level) level = 0
  if (level > 3) return false;
  if (element?.className?.includes('tabulator-footer')) return true;
  if (element?.parentElement) return isRowInFooter(element.parentElement, level+1)
  return false;
}

export const formatterSum = function(cell, formatterParams, onRendered) {  
  const span = document.createElement('span');  
  const root = createRoot(span);  
  root.render(
    <Bs4Sum
      cell={cell} 
      formatterParams={formatterParams}
    />        
  )

  onRendered(() => {    
    const lines = getHeight({cell, formatterParams})
    cell.getElement().style.height = (lines * 19)+'px';    
  })

  return span;  
}

const Bs4TooltipTitle = (props) => {

  return (
    <span style={{wordSpacing: 'normal'}}>
      <span>razem</span> <span style={{fontWeight: 'bold'}}>{props.columnName}</span> <span>({props.type})</span>
    </span>
  )
}

const Bs4Sum = (props) => {
  const {cell, formatterParams} = props;
  const ref = React.useRef(null);
  const views = React.useMemo(() => {
    const footer = isRowInFooter(cell.getRow().getElement())
    const value = cell.getValue();
    const bs4Totals = formatterParams.bs4Totals();
    const column = cell.getColumn();
    const field = column.getField();
    let total = null;
    if (bs4Totals) total = bs4Totals[field];
    
    const value1 = getMoney(value, formatterParams);
    const total1 = getMoney(total, formatterParams);
    
    // 2025-01-28 61453 – Podsumowanie zaznaczonych wierszy [Core]
    const tabulator = cell.getRow().getTable();
    const selectedData = tabulator.getSelectedData();
    const selectedSumValue = getMoney(selectedData.reduce((valueSum, data) => valueSum + data[field], 0), formatterParams);

    const name = column.getDefinition().title;
    // "razem [nazwa kolumny] (strona/zestawienie/zaznaczone):"   
    const views = [(
      <Tooltip placement='top' arrow title={<Bs4TooltipTitle columnName={name} type='strona'/>}>
        <span>{value1}</span>
      </Tooltip>
    )]

    if (total && footer && bs4Totals.lastPage > 1) {
      const vvvv = [...views];
      console.log('...???...', vvvv, views);
      views.push(
        <Tooltip placement='top' arrow title={<Bs4TooltipTitle columnName={name} type='zestawienie'/>}>
          <br/><span>{total1}</span>
        </Tooltip>
      );
    }

    if (selectedData.length > 0) {
      views.push(
        <Tooltip placement='top' arrow title={<Bs4TooltipTitle columnName={name} type='zaznaczone'/>}>
          <br/><span>({selectedData.length}) {selectedSumValue}</span>
        </Tooltip>
      );        
    }    

    return views;
  }, [cell, formatterParams]);

  return (
    <React.Fragment>
      {views.map((view, index) => {
         return <React.Fragment key={index}>{view}</React.Fragment>
      })}
    </React.Fragment>
  )
}

const getHeight = (props) => {
  const {cell, formatterParams} = props;
  const footer = isRowInFooter(cell.getRow().getElement())
  const bs4Totals = formatterParams.bs4Totals();
  const column = cell.getColumn();
  const field = column.getField();
  let total = null;
  if (bs4Totals) total = bs4Totals[field];
  
  const tabulator = cell.getRow().getTable();
  const selectedData = tabulator.getSelectedData();

  let lines = 1;
  if (total && footer && bs4Totals.lastPage > 1) lines++;
  if (selectedData.length > 0) lines++;

  return lines;
}